import React from 'react'
import './index.less'

interface Props {
  show: boolean
  onClose: () => void
  onClick?: () => void
  imgUrl: string
  text?: string
}

const FullScreenPopup = ({
  show,
  onClose,
  onClick = () => {},
  imgUrl,
  text = ''
}: Props) => {
  return (
    <div className={`full-screen-popup ${show ? 'show' : ''}`}>
      <div className="full-screen-popup__mask"></div>
      <div className='full-screen-popup__content'>
        <div className="wrap" onClick={onClick}>
          <img src={imgUrl} alt="" className='img' />
          {
            text ?
            <div className="desc">
              <div className='text'>{text}</div>
              <img alt='' className='icon' src={require('../../assets/arrow_right.png')} />
            </div> : null
          }
        </div>
        <img className='close' alt='' src={require('../../assets/popup_close.png')} onClick={onClose} />
      </div>
    </div>
  )
}

export default FullScreenPopup